const colors = {
    primary: 'hsl(172, 67%, 45%)',
    dark: 'hsl(183, 100%, 15%)',
    darkGray: 'hsl(186, 14%, 43%)',
    gray: 'hsl(184, 14%, 56%)',
    lightGray: 'hsl(185, 41%, 84%)',
    light: 'hsl(189, 41%, 97%)',
    white: 'hsl(0, 0%, 100%)',
    red:'red'
}


const fonts = {
    extraLarge: '40px',
    large: '28px',
    normal: '24px',
    small: '20px'
}

export {fonts, colors}